import axios from 'axios'
import * as Common from './CommonCode'

// const oauth = require('axios-oauth-client');
// const tokenProvider = require('axios-token-interceptor');
const axiosInstance = axios.create({
  baseURL: Common.host
})

axiosInstance.defaults.headers.common['Accept'] = 'application/json'
axiosInstance.defaults.timeout = 15000

export default axiosInstance



// WEBPACK FOOTER //
// ./src/common/AxiosConfig.js